import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./cart";
import { captureReferralFromUrl } from "./referral";
import { initAnalytics, trackFunnel } from "./analytics";

import Header from "./components/Header";
import Hero from "./components/Hero";
import DropTeaser from "./components/DropTeaser";
import Manifesto from "./components/Manifesto";
import Shop from "./components/Shop";
import Lookbook from "./components/Lookbook";
import Ambassador from "./components/Ambassador";
import Newsletter from "./components/Newsletter";
import Partners from "./components/Partners";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Success from "./components/Success";
import Admin from "./components/Admin";
import AmbassadorPortal from "./components/AmbassadorPortal";
import EmailPopup from "./components/EmailPopup";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";
import AscentDrop from "./components/AscentDrop";
import { AthletesBrowse, AthleteProfile, AthleteSubmit, ScoutPortal } from "./components/Athletes";

function Home() {
    return (
        <div className="App grain" data-testid="home-page">
            <Header />
            <main>
                <Hero />
                <DropTeaser />
                <Manifesto />
                <Shop />
                <Lookbook />
                <Ambassador />
                <Partners />
                <Newsletter />
            </main>
            <Footer />
            <CartDrawer />
            <EmailPopup />
        </div>
    );
}

export default function App() {
    useEffect(() => {
        initAnalytics();
        captureReferralFromUrl();
        trackFunnel("page_view");
    }, []);

    return (
        <CartProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/portal" element={<AmbassadorPortal />} />
                    <Route path="/success" element={<Success />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                    <Route path="/drops/ascent" element={<AscentDrop />} />
                    <Route path="/athletes" element={<AthletesBrowse />} />
                    <Route path="/athletes/submit" element={<AthleteSubmit />} />
                    <Route path="/scouts" element={<ScoutPortal />} />
                    <Route path="/athletes/:slug" element={<AthleteProfile />} />
                    <Route path="/shop/:productId" element={<Home />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="bottom-left"
                toastOptions={{
                    style: {
                        background: "#121212",
                        border: "1px solid rgba(255,255,255,0.1)",
                        color: "#fff",
                        fontFamily: "Manrope, system-ui, sans-serif",
                        borderRadius: 0,
                    },
                }}
            />
        </CartProvider>
    );
}
